import { useState, useEffect } from "react";
import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import OrderReturn from "../../components/dashboard/orderPartials/OrderReturn";
import { useGeneral } from "../../components/contexts/GeneralContext";
import axios from "../../config/axios";
import { useParams } from "react-router-dom";
import ApiErrorMessage from "../../components/common/ApiErrorMessage";
import NoItemsFound from "../../components/common/NoItemsFound";
import FullScreenLoading from "../../components/common/loading/FullScreenLoading";
const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState([]);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();
  const { id } = useParams();
  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get(`/dashboard/orders/${id}`);

        if (active) setContent(data?.items);
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load plans. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { content, loading, error, discountCoupons };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};

const OrderProductsReturnPage = () => {
  const { content, loading, error, discountCoupons } = usePageContent();
  useScrollToTop();

  return (
    <PageWrapper loading={false} className="bg-bg min-h-screen">
      <Header code={discountCoupons} />
      {loading && <FullScreenLoading />}
      <BodyWrapper>
        <Wrapper
          goBack={true}
          component={
            !loading && error ? (
              <ApiErrorMessage
                message1="Failed to load order details"
                message2="Please check your connection and try again."
              />
            ) : !loading && !content ? (
              <NoItemsFound
                message1="Order details unavailable"
                message2="Please check back later."
              />
            ) : (
              !loading && content && <OrderReturn order={content} />
            )
          }
        />
      </BodyWrapper>

      <Footer />
    </PageWrapper>
  );
};

export default OrderProductsReturnPage;
